export default class RefreshTokenExpError extends Error {
  message: string

  constructor(message?: string) {
    super(message)
    Object.setPrototypeOf(this, RefreshTokenExpError.prototype)

    if (message === undefined) message = "Token expired"
    this.message = message
  }
}